import React, { useEffect, useRef } from 'react';
import styles from './BalanceTop.module.css';
import { ReactComponent as BeastCoin } from '../../assets/beastCoin.svg';
import { useBalanceStore } from '../../store/BalanceStore';

export default function BalanceTop() {
  const ref = useRef<HTMLDivElement>(null);
  const balance = useBalanceStore((state) => state.balance);
  useEffect(() => {
    const WA = window.Telegram?.WebApp;

    const place = () => {
      const safeTop = WA?.safeAreaInset?.top ?? 0;
      // просто ставим сразу после safeTop
      if (ref.current) {
        ref.current.style.top = `${safeTop + 8}px`;
      }
    };

    place();
    WA?.onEvent?.('safe_area_changed', place);
    WA?.onEvent?.('viewport_changed', place);

    return () => {
      WA?.offEvent?.('safe_area_changed', place);
      WA?.offEvent?.('viewport_changed', place);
    };
  }, []);

  return (
    <div className={styles.wrap} ref={ref}>
      <div className={styles.balance}>
        <BeastCoin className={styles.icon} />
        <span className={styles.text}>{balance}</span>
      </div>
    </div>
  );
}
